import { create } from 'zustand'

/**
 * The one guided tour playing, if any (organizer product tours, 28 Oct 2026). Any button may start a
 * tour by id without prop drilling; the host (OrganizerTour) renders it. `menuHold` is read by the
 * organizer side menu (useOrgSideState): while set, the panel stays unfolded (drawer open ≤ 1100) and
 * `group` forces that accordion group open, so a step can point at a menu row. `sectionHold` is read by
 * the accordion pages (useTourSectionHold): while set, that section card (`tourKey`) is open.
 */
export const useTourStore = create((set) => ({
    activeId: null,
    current: 0,
    auto: false,
    menuHold: null, // null | { group?: string | null }
    sectionHold: null, // null | tourKey of the OrganizerSection a step wants open
    start: (id, { auto = false, at = 0 } = {}) =>
        set({ activeId: id, current: at, auto, menuHold: null, sectionHold: null }),
    stop: () => set({ activeId: null, current: 0, auto: false, menuHold: null, sectionHold: null }),
    setCurrent: (current) => set({ current }),
    setMenuHold: (menuHold) => set({ menuHold }),
    setSectionHold: (sectionHold) => set({ sectionHold }),
}))

export default useTourStore
